// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Shell (collapsed / expanded card) ——— */
.stitch-appt-shell {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  overflow: hidden;
}

.stitch-appt-shell.is-interactive {
  cursor: pointer;
}

.stitch-appt-shell.is-interactive:hover {
  border-color: #BAE6FD;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}

.stitch-appt-shell.is-open {
  border: 2px solid #0EA5E9;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.12);
  cursor: default;
  /* Stitch: p-4 + space-y-3.5 (14px) between sections */
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.stitch-appt-shell__header,
.stitch-appt-shell__body,
.stitch-appt {
  min-width: 0;
  max-width: 100%;
}

.stitch-appt-shell__header {
  outline: none;
}

.stitch-appt-shell.is-interactive .stitch-appt-shell__header:focus-visible {
  box-shadow: inset 0 0 0 2px rgba(14, 165, 233, 0.35);
}

.stitch-appt-shell__body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 0;
}

/* ——— Collapsed / header face ——— */
.stitch-appt {
  box-sizing: border-box;
  padding: 12px;
  width: 100%;
}

.stitch-appt-shell.is-open .stitch-appt {
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.stitch-appt__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.stitch-appt-shell:not(.is-open) .stitch-appt__row {
  margin-bottom: 8px;
}

.stitch-appt__who {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
}

.stitch-appt__time {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #0EA5E9;
  background: #E0F2FE;
  padding: 2px 8px;
  border-radius: 4px;
  line-height: 1.4;
}

.stitch-appt.is-invisit .stitch-appt__time {
  color: #0284C7;
}

.stitch-appt__name {
  font-size: 14px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.25;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stitch-appt-shell.is-open .stitch-appt__name {
  font-size: 15px;
}

.stitch-appt__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 2px 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  border: 1px solid transparent;
  white-space: nowrap;
}

.stitch-appt__dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
  flex-shrink: 0;
}

.stitch-appt__status.is-waiting {
  background: #FFFBEB;
  color: #D97706;
  border-color: #FDE68A;
}

.stitch-appt__status.is-waiting .stitch-appt__dot {
  background: #F59E0B;
}

.stitch-appt__status.is-invisit {
  background: #E0F2FE;
  color: #0284C7;
  border-color: #BAE6FD;
}

.stitch-appt__status.is-invisit .stitch-appt__dot {
  background: #0EA5E9;
}

.stitch-appt__status.is-confirmed,
.stitch-appt__status.is-finished {
  background: #ECFDF5;
  color: #059669;
  border-color: #A7F3D0;
}

.stitch-appt__status.is-confirmed .stitch-appt__dot,
.stitch-appt__status.is-finished .stitch-appt__dot {
  background: #10B981;
}

.stitch-appt__status.is-pending,
.stitch-appt__status.is-unreached,
.stitch-appt__status.is-afterwork {
  background: #F8FAFC;
  color: #64748B;
  border-color: #E2E8F0;
}

.stitch-appt__status.is-cancel,
.stitch-appt__status.is-postpone {
  background: #FEF2F2;
  color: #DC2626;
  border-color: #FECACA;
}

.stitch-appt__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid #F8FAFC;
  font-size: 12px;
  color: #64748B;
}

.stitch-appt-shell:not(.is-open) .stitch-appt.is-invisit {
  background: rgba(240, 249, 255, 0.55);
}

.stitch-appt-shell:not(.is-open) .stitch-appt.is-invisit .stitch-appt__footer {
  border-top-color: rgba(224, 242, 254, 0.7);
}

.stitch-appt__phone {
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #475569;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stitch-appt__code {
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  background: #F1F5F9;
  color: #64748B;
  padding: 2px 6px;
  border-radius: 4px;
}

/* ——— Expanded context box ——— */
.stitch-appt__context {
  padding: 10px;
  border-radius: 8px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
}

.stitch-appt__context-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
  margin-bottom: 4px;
}

.stitch-appt__muted {
  color: #64748B;
  flex-shrink: 0;
}

.stitch-appt__context-pkg {
  font-weight: 500;
  color: #0F172A;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: end;
}

.stitch-appt__context-bottom {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  min-width: 0;
}

.stitch-appt__sep {
  color: #94A3B8;
  flex-shrink: 0;
}

/* ——— Status actions ——— */
.stitch-appt-shell__actions-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748B;
  margin-bottom: 6px;
}

.stitch-appt-shell__actions-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.stitch-status-btn {
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  height: 28px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.stitch-status-btn:hover {
  background: #F8FAFC;
}

.stitch-status-btn.tone-primary {
  grid-column: 1 / -1;
  height: 32px;
  background: #0EA5E9;
  border-color: #0EA5E9;
  color: #ffffff;
  font-weight: 600;
  font-size: 12px;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.stitch-status-btn.tone-primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.stitch-status-btn.tone-warning {
  border-color: #FDE68A;
  background: #FFFBEB;
  color: #D97706;
}

.stitch-status-btn.tone-warning:hover {
  background: #FEF3C7;
}

.stitch-status-btn.tone-success {
  border-color: #A7F3D0;
  background: #ECFDF5;
  color: #059669;
}

.stitch-status-btn.tone-danger {
  border-color: #FECACA;
  background: #FEF2F2;
  color: #DC2626;
}

.stitch-status-btn.tone-danger:hover {
  background: #FEE2E2;
}

/* Lone secondary after a full-width primary fills the row */
.stitch-appt-shell__actions-grid > .stitch-status-btn.tone-primary + .stitch-status-btn:last-child {
  grid-column: 1 / -1;
}

/* ——— Bottom links ——— */
.stitch-appt-shell__links {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid #E2E8F0;
  font-size: 12px;
}

.stitch-appt-shell__open {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  color: #0EA5E9;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  padding: 0;
}

.stitch-appt-shell__open:hover {
  color: #0284C7;
}

.stitch-appt-shell__link-tools {
  display: flex;
  align-items: center;
  gap: 4px;
}

.stitch-appt-shell__icon-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #64748B;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.stitch-appt-shell__icon-btn:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.stitch-appt-note {
  width: 220px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stitch-appt-note__actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/cards/HomeCard/style.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,0DAA0D;EAC1D,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,+CAA+C;EAC/C,eAAe;EACf,sDAAsD;EACtD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;EAGE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,6EAA6E;EAC7E,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,6EAA6E;EAC7E,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,6EAA6E;EAC7E,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV","sourcesContent":["/* ——— Shell (collapsed / expanded card) ——— */\n.stitch-appt-shell {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  overflow: hidden;\n}\n\n.stitch-appt-shell.is-interactive {\n  cursor: pointer;\n}\n\n.stitch-appt-shell.is-interactive:hover {\n  border-color: #BAE6FD;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n}\n\n.stitch-appt-shell.is-open {\n  border: 2px solid #0EA5E9;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.12);\n  cursor: default;\n  /* Stitch: p-4 + space-y-3.5 (14px) between sections */\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.stitch-appt-shell__header,\n.stitch-appt-shell__body,\n.stitch-appt {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.stitch-appt-shell__header {\n  outline: none;\n}\n\n.stitch-appt-shell.is-interactive .stitch-appt-shell__header:focus-visible {\n  box-shadow: inset 0 0 0 2px rgba(14, 165, 233, 0.35);\n}\n\n.stitch-appt-shell__body {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 0;\n}\n\n/* ——— Collapsed / header face ——— */\n.stitch-appt {\n  box-sizing: border-box;\n  padding: 12px;\n  width: 100%;\n}\n\n.stitch-appt-shell.is-open .stitch-appt {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.stitch-appt__row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.stitch-appt-shell:not(.is-open) .stitch-appt__row {\n  margin-bottom: 8px;\n}\n\n.stitch-appt__who {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex: 1;\n}\n\n.stitch-appt__time {\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: #0EA5E9;\n  background: #E0F2FE;\n  padding: 2px 8px;\n  border-radius: 4px;\n  line-height: 1.4;\n}\n\n.stitch-appt.is-invisit .stitch-appt__time {\n  color: #0284C7;\n}\n\n.stitch-appt__name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.25;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.stitch-appt-shell.is-open .stitch-appt__name {\n  font-size: 15px;\n}\n\n.stitch-appt__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.4;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.stitch-appt__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n  flex-shrink: 0;\n}\n\n.stitch-appt__status.is-waiting {\n  background: #FFFBEB;\n  color: #D97706;\n  border-color: #FDE68A;\n}\n\n.stitch-appt__status.is-waiting .stitch-appt__dot {\n  background: #F59E0B;\n}\n\n.stitch-appt__status.is-invisit {\n  background: #E0F2FE;\n  color: #0284C7;\n  border-color: #BAE6FD;\n}\n\n.stitch-appt__status.is-invisit .stitch-appt__dot {\n  background: #0EA5E9;\n}\n\n.stitch-appt__status.is-confirmed,\n.stitch-appt__status.is-finished {\n  background: #ECFDF5;\n  color: #059669;\n  border-color: #A7F3D0;\n}\n\n.stitch-appt__status.is-confirmed .stitch-appt__dot,\n.stitch-appt__status.is-finished .stitch-appt__dot {\n  background: #10B981;\n}\n\n.stitch-appt__status.is-pending,\n.stitch-appt__status.is-unreached,\n.stitch-appt__status.is-afterwork {\n  background: #F8FAFC;\n  color: #64748B;\n  border-color: #E2E8F0;\n}\n\n.stitch-appt__status.is-cancel,\n.stitch-appt__status.is-postpone {\n  background: #FEF2F2;\n  color: #DC2626;\n  border-color: #FECACA;\n}\n\n.stitch-appt__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #F8FAFC;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.stitch-appt-shell:not(.is-open) .stitch-appt.is-invisit {\n  background: rgba(240, 249, 255, 0.55);\n}\n\n.stitch-appt-shell:not(.is-open) .stitch-appt.is-invisit .stitch-appt__footer {\n  border-top-color: rgba(224, 242, 254, 0.7);\n}\n\n.stitch-appt__phone {\n  font-variant-numeric: tabular-nums;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: #475569;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.stitch-appt__code {\n  flex-shrink: 0;\n  font-variant-numeric: tabular-nums;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n  background: #F1F5F9;\n  color: #64748B;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n/* ——— Expanded context box ——— */\n.stitch-appt__context {\n  padding: 10px;\n  border-radius: 8px;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n}\n\n.stitch-appt__context-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.stitch-appt__muted {\n  color: #64748B;\n  flex-shrink: 0;\n}\n\n.stitch-appt__context-pkg {\n  font-weight: 500;\n  color: #0F172A;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: end;\n}\n\n.stitch-appt__context-bottom {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  min-width: 0;\n}\n\n.stitch-appt__sep {\n  color: #94A3B8;\n  flex-shrink: 0;\n}\n\n/* ——— Status actions ——— */\n.stitch-appt-shell__actions-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748B;\n  margin-bottom: 6px;\n}\n\n.stitch-appt-shell__actions-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 6px;\n}\n\n.stitch-status-btn {\n  box-sizing: border-box;\n  min-width: 0;\n  width: 100%;\n  height: 28px;\n  padding: 0 8px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.stitch-status-btn:hover {\n  background: #F8FAFC;\n}\n\n.stitch-status-btn.tone-primary {\n  grid-column: 1 / -1;\n  height: 32px;\n  background: #0EA5E9;\n  border-color: #0EA5E9;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 12px;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.stitch-status-btn.tone-primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.stitch-status-btn.tone-warning {\n  border-color: #FDE68A;\n  background: #FFFBEB;\n  color: #D97706;\n}\n\n.stitch-status-btn.tone-warning:hover {\n  background: #FEF3C7;\n}\n\n.stitch-status-btn.tone-success {\n  border-color: #A7F3D0;\n  background: #ECFDF5;\n  color: #059669;\n}\n\n.stitch-status-btn.tone-danger {\n  border-color: #FECACA;\n  background: #FEF2F2;\n  color: #DC2626;\n}\n\n.stitch-status-btn.tone-danger:hover {\n  background: #FEE2E2;\n}\n\n/* Lone secondary after a full-width primary fills the row */\n.stitch-appt-shell__actions-grid > .stitch-status-btn.tone-primary + .stitch-status-btn:last-child {\n  grid-column: 1 / -1;\n}\n\n/* ——— Bottom links ——— */\n.stitch-appt-shell__links {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding-top: 10px;\n  border-top: 1px solid #E2E8F0;\n  font-size: 12px;\n}\n\n.stitch-appt-shell__open {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: none;\n  background: transparent;\n  color: #0EA5E9;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  padding: 0;\n}\n\n.stitch-appt-shell__open:hover {\n  color: #0284C7;\n}\n\n.stitch-appt-shell__link-tools {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.stitch-appt-shell__icon-btn {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: #64748B;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stitch-appt-shell__icon-btn:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.stitch-appt-note {\n  width: 220px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.stitch-appt-note__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
